<div class="main-section tryagain-page text-center">
    <img src="https://images.5paisa.com/SPOT/activation/try-again.png" />
    <h4>Couldn’t fetch details</h4>
    <!-- <p>We couldn’t find the account with your mobile number
        Please try again or add details manually.</p> -->
        <button type="button" class="btn--primary" (click)="submit()">try Again</button>
    <div class="bottom-button-wrapper btn">
        <span (click)="openBottomSheet()">Add Bank Details Manually</span>
    </div>
    @if(btnLoader){
        <div class="bottom-button-wrapper btn">
            <button class="btn btn--primary">
                <span class="stage">
                    <span class="dot-pulse"></span>
                </span>
            </button>
        </div>
    }
   
</div>